import React from 'react';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';

// --- 発表データ（タイトル・著者・学会名は学術的正式名称のため翻訳しない） ---
const publicationsData = [
  {
    id: 1,
    year: 2026,
    category: 'domestic',
    type: 'oral',
    title: '多チャンネル筋電位とIMUを用いたアシストグローブの把持動作識別',
    authors: [
      { name: '吉田壮汰', isMe: true },
    ],
    venue: '日本人間工学会第67回大会',
    location: '名古屋市立大学',
    date: '2026年5月',
  },
  {
    id: 2,
    year: 2025,
    category: 'domestic',
    type: 'oral',
    title: '総指伸筋の筋電位を用いたアシストグローブにおける把持動作予測手法の評価',
    authors: [
      { name: '吉田壮汰', isMe: true },
    ],
    venue: '日本人間工学会関西支部大会2025',
    location: '京都工芸繊維大学',
    date: '2025年12月',
  },
  {
    id: 3,
    year: 2025,
    category: 'domestic',
    type: 'poster',
    title: 'アシストグローブにおける筋電位を用いた把持動作検出手法の検討',
    authors: [
      { name: '吉田壮汰', isMe: true },
    ],
    venue: 'ヒューマンインターフェースシンポジウム2025',
    location: '金沢工業大学',
    date: '2025年9月',
    cinii: 'https://cir.nii.ac.jp/crid/1520025584752403968',
  },
];

// --- コンポーネント ---
const Publication = () => {
  const { t } = useTranslation();

  // 年度でグループ化
  const groupedByYear = publicationsData.reduce((acc, pub) => {
    if (!acc[pub.year]) acc[pub.year] = [];
    acc[pub.year].push(pub);
    return acc;
  }, {});

  // 年度を降順にソート
  const sortedYears = Object.keys(groupedByYear)
    .map(Number)
    .sort((a, b) => b - a);

  return (
    <PageLayout>
      <div id="publication" className="publication-container-inner">
        <h2 className="page-first-heading">{t('publication.title')}</h2>

        {/* 発表リスト */}
        <div className="publication-list">
          {sortedYears.length === 0 ? (
            <div className="publication-empty">
              <span className="publication-empty-icon">📄</span>
              <p>{t('publication.empty')}</p>
            </div>
          ) : (
            sortedYears.map((year) => (
              <div key={year}>
                <h3 className="publication-year-heading">{year}{t('publication.year_suffix')}</h3>
                {groupedByYear[year].map((pub, idx) => (
                  <div
                    key={pub.id}
                    className="publication-card"
                    style={{ animationDelay: `${idx * 0.08}s` }}
                  >
                    {/* バッジ */}
                    <div className="publication-card-header">
                      <span className={`publication-badge ${pub.type}`}>
                        {t(`publication.badge.${pub.type}`)}
                      </span>
                    </div>

                    {/* タイトル */}
                    <h4 className="publication-title">
                      {pub.cinii ? (
                        <a href={pub.cinii} target="_blank" rel="noopener noreferrer">
                          {pub.title}
                        </a>
                      ) : (
                        pub.title
                      )}
                    </h4>

                    {/* 著者 */}
                    <p className="publication-authors">
                      {pub.authors.map((author, i) => (
                        <React.Fragment key={i}>
                          {i > 0 && ', '}
                          {author.isMe ? (
                            <span className="me">{author.name}</span>
                          ) : (
                            <span>{author.name}</span>
                          )}
                        </React.Fragment>
                      ))}
                    </p>

                    {/* 学会名・場所・日時 */}
                    <p className="publication-venue">
                      <span className="venue-name">{pub.venue}</span>
                      {pub.location && <>, {pub.location}</>}
                      {pub.date && <>, {pub.date}</>}
                    </p>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default Publication;
